export const SIDE_PANE_DEFAULT_WIDTH = 320
export const DATA_CONNECTION_PANE_WIDTH = 800
export const SIDE_PANE_ANIMATION_DURATION = 500
